import { api, ApiError } from "@/api/api";
import { AssetsReadyForValidationResponseData } from "@/api/validation-types";
import { useEffect, useState } from "react";

export function useAssetsReadyForValidation() {
  const [data, setData] = useState<AssetsReadyForValidationResponseData>([]);
  const [error, setError] = useState<ApiError | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    api.validation.assetsReadyForValidation
      .get()
      .then((data) => {
        setData(data);
        setIsLoading(false);
      })
      .catch((error) => {
        setError(error);
        setIsLoading(false);
      });
  }, []);

  return { data, error, isLoading };
}
